// Lightweight event-delegated accordion for the action-plan tree picker.
// Clicks on `[data-accordion-toggle]` toggle the expansion of the closest
// `[data-accordion-node]` without navigating, so the user can browse the tree
// before deciding which node to select via the row link.
document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-accordion-toggle]")
  if (!toggle) return

  event.preventDefault()
  event.stopPropagation()

  const node = toggle.closest("[data-accordion-node]")
  if (!node) return

  const panel = node.querySelector(":scope > [data-accordion-panel]")
  if (!panel) return

  const isExpanded = node.getAttribute("data-accordion-expanded") === "true"
  node.setAttribute("data-accordion-expanded", String(!isExpanded))
  toggle.setAttribute("aria-expanded", String(!isExpanded))

  if (isExpanded) {
    panel.setAttribute("hidden", "")
  } else {
    panel.removeAttribute("hidden")
  }
})
